import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { useTheme } from '../../theme';
import { fs, s } from '../../utils/libs';

type SupportUnreadBadgeProps = {
  count: number;
  size?: 'small' | 'default';
};

const SupportUnreadBadge: React.FC<SupportUnreadBadgeProps> = ({
  count,
  size = 'default',
}) => {
  const { theme } = useTheme();
  const styles = createStyles(theme);

  if (count <= 0) return null;

  return (
    <View style={[styles.badge, size === 'small' && styles.badgeSmall]}>
      <Text style={[styles.text, size === 'small' && styles.textSmall]}>
        {count > 99 ? '99+' : String(count)}
      </Text>
    </View>
  );
};

const createStyles = (theme: any) =>
  StyleSheet.create({
    badge: {
      position: 'absolute',
      top: s(-5),
      right: s(-5),
      minWidth: s(18),
      height: s(18),
      borderRadius: s(9),
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: theme.colors.errorDark,
      borderWidth: s(1),
      borderColor: theme.colors.textInverse,
    },
    badgeSmall: {
      top: s(-7),
      right: s(-7),
      minWidth: s(16),
      height: s(16),
      borderRadius: s(8),
      paddingHorizontal: s(3),
    },
    text: {
      color: theme.colors.textInverse,
      fontSize: fs(10),
      lineHeight: fs(12),
      fontWeight: '700',
    },
    textSmall: {
      fontSize: fs(9),
      lineHeight: fs(11),
    },
  });

export default SupportUnreadBadge;
